import styled from 'styled-components';

export const Content = styled.div`
  padding: 3.25rem 2rem 3rem;
  text-align: center;
  max-width: 500px;
  margin: auto;

  h3 {
    font-family: ${({ theme }) => theme.fonts.primary.bold};
    margin-bottom: 1rem;
  }
`;

export const Description = styled.p`
  text-align: center;
  margin-bottom: 2rem;
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;

  a {
    width: 100%;

    &:not(:last-child) {
      margin-bottom: 1rem;
    }
  }
`;
